import * as React from 'react';

import { translate } from '~l10n/client';

import { PaywallScreens } from '~analytics/types';
import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallFeatureList,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export type Props = Pick<DialogProps, 'open' | 'onClose'>;

export function StudentScorePaywall(props: Props) {
  return (
    <PaywallDialog.Long
      id="rooms-paywall"
      title={translate('Upgrade to Manually Grade')}
      actions={[
        <UIButton key="cancel" onClick={props.onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={PaywallScreens.ResultsAddManualGrade}
        />,
      ]}
      closeLabel={translate('Close')}
      {...props}
      paywallTouch={[PaywallScreens.ResultsAddManualGrade]}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate(
          'Manually grade short answer responses from the results table after finishing a quiz. Upgrade to Socrative Pro for more features:'
        )}
      </p>
      <PaywallFeatureList
        features={[
          { text: translate('Run multiple quizzes at once') },
          { text: translate('Give partial marks') },
          { text: translate('Customize reporting') },
        ]}
      />
    </PaywallDialog.Long>
  );
}
